import { render } from "./FishGrid.vue?vue&type=template&id=e8b3a726&scoped=true"
import script from "./FishGrid.vue?vue&type=script&lang=js"
export * from "./FishGrid.vue?vue&type=script&lang=js"

import "./FishGrid.vue?vue&type=style&index=0&id=e8b3a726&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8b3a726"]])

export default __exports__